import { ImageType } from 'core/utils/Constants';

const imageHasUrl = ({ cdnUrl, image600, thumbnail }) => !!(cdnUrl || image600 || thumbnail);

export default function getFeaturedImage({ listingImages }) {
	const numImages = listingImages.length;
	for (let i = 0; i < numImages; i++) {
		let img = listingImages[i];
		if (img.listingImageType === ImageType.PRIMARY_IMAGE && imageHasUrl(img)) {
			return img;
		}
	}
	// default to first one with url:
	return listingImages.find(imageHasUrl) || {};
}

export function getAltImage({ listingImages }) {
	// Get the first OTHER_IMAGE
	const numImages = listingImages.length;
	for (let i = 0; i < numImages; i++) {
		let img = listingImages[i];
		if (img.listingImageType === ImageType.OTHER_IMAGE) {
			return img;
		}
	}
}
